<template>
  <div class="secondary fs-lock">
    <h-alert type="error" max-width="90%">
      <p>{{ __('blockMessage') }}</p>
      <v-btn text color="white" @click="logout()">
        <v-icon left v-text="icons.logout" />
        {{ __('logout') }}
      </v-btn>
    </h-alert>
  </div>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import Logout from '@/Mixins/AuthLogout'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HAlert from '@/Components/Messages/Alert'

  export default {
    mixins: [
      I18n,
      Logout,
      UsesIcons,
    ],

    components: {
      HAlert,
    },
  }
</script>

<style lang="scss" scoped>
.fs-lock {
  position: absolute;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  padding-top: 12rem;
}
</style>
